import React, { useEffect, useState } from "react";

import { ReactComponent as Spinner } from "../../_assets/imgs/spinner-solid.svg";

import "./system-diagnostic.styles.css";

const SYSTEM_DIAGNOSTIC_TESTS = [
  {
    name: "network",
  },
  {
    name: "browser",
  },
  {
    name: "platform",
  },
  {
    name: "cpu",
  },
  {
    name: "full system",
  },
];

const SystemDiagnostic = ({ status, index, changeDiagnosticResults }) => {
  const [systemTests, setSystemTests] = useState([]);

  useEffect(() => {
    if (status === "error" || status === "successful" || status === "pending")
      return;
    const finalSystemTest = SYSTEM_DIAGNOSTIC_TESTS.map((test, i) => {
      test["status"] = i === 0 ? status : "pending";
      test["result"] = null;
      return test;
    });
    setSystemTests(finalSystemTest);
  }, [status]);

  const setResult = (index, result, status) => {
    const newSystemTests = [...systemTests];
    newSystemTests[index]["result"] = result;
    newSystemTests[index]["status"] = status;
    if (newSystemTests[index + 1] && status !== "error") {
      newSystemTests[index + 1]["status"] = "running";
    }
    setSystemTests(newSystemTests);
  };

  const pause = ()=>{
    return new Promise((resolve,reject)=>{
      setTimeout(()=>{resolve()},1000)
    })

  } 
  const checkNetworkConnection = async(index) => {
    let networkTotal = 0;
    for (let i = 0; i < 5; i++) {
      networkTotal += navigator?.connection?.downlink;
      await pause();
    }
    const netAvg = networkTotal / 5;
    // console.log(netAvg,networkTotal,'network');
    if(netAvg<2)  return setResult(index, `${netAvg} Mbps`, "error");
    setResult(index, `${netAvg} Mbps`, "successful");
  };

  const checkBrowserversion = (index) => {
    const browserVer = () => {
      var ua = navigator.userAgent;
      var tem;
      var M =
        ua.match(
          /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
        ) || [];
      if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return "IE " + (tem[1] || "");
      }
      if (M[1] === "Chrome") {
        tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
        if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
      }
      M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
      if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
      return M.join(" ");
    };

    const sayswho = browserVer();
    // console.log(navigator.userAgentData.brands); use this if upper method stop working
    setResult(index, sayswho, "successful");
  };

  const checkPlatform = (index) => {
    const platform =
      navigator?.userAgentData?.platform || navigator?.platform || "unknown";
    setResult(index, platform, "successful");
  };

  const checkConcurrency = (index) => {
    const concurrency = navigator.hardwareConcurrency;
    setResult(index, `${concurrency} cores cpu`, "successful");
  };

  const checkFullSystem = (index) => {
    const userAgent = navigator.userAgent;
    setResult(index, userAgent, "successful");
  };

  const checkMethodToRun = () => {
    for (let i = 0; i < systemTests.length; i++) {
      if (systemTests[i].status === "error") {
        console.log("error");
        return changeDiagnosticResults(index, systemTests, "error");
      }
      if (systemTests[i].name === "network") {
        if (systemTests[i].status === "running") {
          return checkNetworkConnection(i);
        }
      }
      if (systemTests[i].name === "browser") {
        if (systemTests[i].status === "running") {
          return checkBrowserversion(i);
        }
      }
      if (systemTests[i].name === "platform") {
        if (systemTests[i].status === "running") {
          return checkPlatform(i);
        }
      }
      if (systemTests[i].name === "cpu") {
        if (systemTests[i].status === "running") {
          return checkConcurrency(i);
        }
      }
      if (systemTests[i].name === "full system") {
        if (systemTests[i].status === "running") {
          return checkFullSystem(i);
        }
      }
    }

    for (let i = 0; i < systemTests.length; i++) {
      if (systemTests[i].status !== "successful") return;
      console.log("successful");
      changeDiagnosticResults(index, systemTests, "successful");
    }
  };

  useEffect(() => {
    checkMethodToRun();
  }, [systemTests]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="diagnostic-details-wrapper">
      <span>
        {status === "running" && <Spinner className="diagnostic-spinner" />}
      </span>
      {status === "successful" && (
        <span className="diagnostic-tick">&#10003;</span>
      )}
      {status === "error" && <span className="diagnostic-error">!</span>}
      <div>
        <span className="diagnostic-test-heading">System Test</span>
        {systemTests.map(({ name, status },index) =>
          status === "running" ? <span key={index}>Running {name} test...</span> : null
        )}
        {status === "successful" && <span>System test was successful</span>}
        {status === "error" && <span>Your system is not compatible</span>}
      </div>
    </div>
  );
};

export default SystemDiagnostic;
